export default {
  metaTitleBrand: "LOYA SPORT",
  metaTitleHome: "Startseite",
  metaTitleProducts: "Produkte",
  metaTitleProductDetail: "Produktdetail",
  metaTitleCustomService: "Individueller Service",
  metaTitleSolutions: "Lösungen",
  metaTitleAbout: "Über uns",
  metaTitleContact: "Kontakt",
  metaTitleBlog: "Blog",
  metaTitleLogin: "Anmelden",
  metaTitleAdmin: "Admin-Dashboard",
  metaTitleSystemSetup: "Systemeinrichtung",

  contactDocsTitle: "Verfügbare Dokumente",
  contactDocsDesc: "Unterstützung für Handelsrechnung, Packliste und Versandkoordination.",
  contactSampleTitle: "Musterdienst",
  contactSampleDesc: "Schnelle Musterabwicklung für OEM- und Private-Label-Projekte.",

  searchOverlayPlaceholder: "Produkte nach Namen suchen...",
  searchOverlaySubmitAria: "Suche absenden",
  searchOverlaySubmitTitle: "Suchen",
  searchOverlayHintPrefix: "Drücken Sie",
  searchOverlayHintSuffix: "um alle passenden Produkte anzuzeigen oder unten ein Schnellergebnis auszuwählen.",
  searchOverlayCloseAria: "Suche schließen",
  searchOverlayQuickResults: "Schnellergebnisse",
  searchOverlayQuickResultsAria: "Schnelle Suchergebnisse",
  searchOverlayFallbackCategory: "Yoga-Zubehör",
  searchOverlayHistory: "Suchverlauf",
  searchOverlayClear: "Leeren",
  searchOverlayNoHistory: "Keine aktuellen Suchanfragen",
  searchOverlayRecommended: "Empfohlene Stichwörter",
  searchOverlayFallbackKeyword: "Yoga-Matte",

  blogHeroKicker: "Content-Center",
  blogHeroTitle: "Insights & Einkaufsleitfäden",
  blogSearchAria: "Artikel suchen",
  blogReadingTimeMin: "Min. Lesezeit",
  blogShowLess: "Weniger anzeigen",
  blogCategoryAria: "Artikelkategorien",
  blogFeaturedPlaceholder: "Empfohlener Insight",
  blogPaginationAria: "Blog-Seitennavigation",
  blogCtaAria: "Blog-Call-to-Action",
  blogCtaDescription: "Unser Team bietet gezielte Empfehlungen und begleitet Sie von der Musterphase bis zur Serienlieferung.",
  blogCtaPrimary: "Jetzt kontaktieren",
  blogCtaSecondary: "Loesungen ansehen",

  requestFreeSample: "Kostenloses Muster anfragen",

  factoryStatsSince: "Seit 1995",
  factoryStatsCapacity: "10.000+ Einheiten pro Monat",
  factoryStatsExport: "Export in über 50 Länder",
  factoryStatsCert: "ISO 9001 & BSCI zertifiziert",

  aboutHeroTitle: "Jung, professionell, fokussiert — Ihre Experten für integrierte Yoga-Lieferketten",
  aboutHeroBody: "LOYA SPORT mit Sitz in Changsha, Hunan, China, verfügt über ein dynamisches und professionelles Team. Wir bieten internationalen Einkäufern sorgfältig ausgewählte Integrationsservices für Yoga-Lieferketten — vom Screening der Ursprungsfabriken bis zur tiefgehenden kundenspezifischen Entwicklung.",
  aboutAddress: "Adresse: Ruihe Kechuang Building, Wanglong Road, Bezirk Yuelu, Changsha, Hunan, China",
  aboutTeamTitle: "Dynamisches & professionelles Team",
  aboutTeamBody: "Wir sind jung und zugleich erfahren und verfügen über ein tiefes Verständnis für Marktanforderungen und technische Details in der Yoga-Branche. Durch strenge Auswahlskriterien und schnelle Reaktionszeiten stellen wir sicher, dass jedes gelieferte Produkt hohen kommerziellen Erwartungen entspricht.",
  aboutCustomizationTitle: "Umfassende Individualisierungsservices",
  aboutCustomizationBody: "Von Logodruck und Verpackungsdesign bis zur Entwicklung produktbezogener Formen bieten wir flexible und tiefgehende Individualisierungslösungen, damit sich Ihre Marke im Markt klar abhebt.",
  aboutFactoryPartnerTitle: "Erstklassige Fabrikpartner",
  aboutFactoryPartnerBody: "Wir arbeiten eng mit ISO-/BSCI-zertifizierten Produktionsstandorten zusammen und kontrollieren die Qualität von der Quelle an, um Produktionsstabilität und pünktliche Lieferung sicherzustellen.",
  aboutHeroKicker: "Lieferketten-Integrator",
  aboutMetric1: "Ein zentrales Projektfenster für Kommunikation zu Produkt, Verpackung und Lieferung",
  aboutMetric2: "Fabrikressourcen unter einer einheitlichen Sourcing- und Follow-up-Struktur koordiniert",
  aboutMetric3: "Workflow entwickelt für Importeure, Einzelhändler, Distributoren und Private-Label-Käufer",
  aboutPlaceholderNote: "Unsere Aufgabe ist es, die fragmentierte Kommunikation zwischen Käufer, Lieferant und Fabrikumsetzungsteams zu reduzieren, damit Projekte klarer und mit weniger blinden Flecken vorankommen.",
  aboutHeroImageAlt: "Treffen zur Lieferkettenkoordination für Exportkäufer",
  aboutHeroCaption: "Von der Anfrage bis zum Versand koordinieren wir die Details, die sonst häufig auf Sourcing-Agenten, Fabriken und Logistikpartner verteilt sind.",
  aboutOfficeImageAlt: "Bürogebäude von Changsha Loya Technology",
  aboutOfficeCaption: "Büro von Changsha Loya Technology",
  aboutTeamImageAlt: "Unser professionelles Team im Büro in Changsha",
  aboutFactoryImageAlt: "Produktionslinie für Yogamatten und Qualitätsworkflow",
  aboutFactoryCollageAlt: "Fabriklager und Produktionsdetails",
  aboutWhatWeDoTitle: "Was wir tatsächlich tun",
  aboutWhatWeDoBody1: "Viele Käufer brauchen nicht einfach nur einen Katalog. Sie brauchen einen Partner, der kommerzielle Anforderungen mit der tatsächlichen Fabrikumsetzung verbinden kann. Genau dort setzen wir an. Wir koordinieren Lieferantenauswahl, Preisabstimmung, Produktmuster, Verpackungsumsetzung, Produktionsnachverfolgung, Prüfungsabstimmung und Exportvorbereitung.",
  aboutWhatWeDoBody2: "Anstatt Produktdetails, Verpackungsdateien, Liefertermine und Bestelländerungen auf mehrere Ansprechpartner zu verteilen, zentralisieren wir den Prozess und halten das Projekt über einen verantwortlichen Kommunikationsweg in Bewegung.",
  aboutBadge1: "Lieferanten-Matching",
  aboutBadge2: "Muster-Follow-up",
  aboutBadge3: "Verpackungsumsetzung",
  aboutBadge4: "Versandbereitschaft",
  aboutSideImageAlt: "Käuferkommunikation und Projektprüfung",
  aboutIntegratedCapabilitiesTitle: "Integrierte Beschaffungskompetenzen",
  aboutSideCaption: "Wir konzentrieren uns darauf, die Beschaffungskette für internationale Käufer leichter steuerbar zu machen, die verlässliche Koordination mehr benötigen als isolierte Handelsaktivitäten.",
  aboutCapabilityCard1Title: "Integration des Lieferantennetzwerks",
  aboutCapabilityCard1Body: "Wir bündeln Fabrikressourcen, Kategorie-Know-how und Sourcing-Kontrollen in einem käuferorientierten Workflow, sodass Sie nicht selbst mehrere Parteien koordinieren müssen.",
  aboutCapabilityCard2Title: "Kommerzielle & technische Koordination",
  aboutCapabilityCard2Body: "Von Angebot, Muster und Verpackungsdetails bis zur Spezifikationsbestätigung und Produktionskontrollpunkten halten wir die kommerzielle und die Fabrikseite aufeinander abgestimmt.",
  aboutCapabilityCard3Title: "Umsetzung für Exportaufträge",
  aboutCapabilityCard3Body: "Wir begleiten Aufträge durch Prüfung, Dokumentation, Buchung und Versandbereitschaft, um Kommunikationslücken und Lieferrisiken zu reduzieren.",
  aboutOperatingModel1: "Kategoriesourcing und Fabrik-Matching basierend auf Ihrem Zielmarkt und Ihrer Preispositionierung.",
  aboutOperatingModel2: "Muster, Spezifikationsprüfung und Verpackungskoordination, bevor die Produktion final festgelegt wird.",
  aboutOperatingModel3: "Produktions-Follow-up, Qualitätskontrollpunkte und Versandvorbereitung in einem durchgängigen Projektablauf.",
  aboutOperatingModel4: "Ein zentrales Kommunikationsfenster für Produkt, Verpackung, Dokumentation und Lieferfortschritt.",
  aboutWhoWeServeTitle: "Wen wir bedienen",
  aboutBuyerScenario1Title: "Für Importeure & Distributoren",
  aboutBuyerScenario1Body: "Wir helfen dabei, Produktlinien zu konsolidieren, Lieferantenoptionen zu vergleichen und einen stabileren Nachschubplan über mehrere Kategorien hinweg aufzubauen.",
  aboutBuyerScenario2Title: "Für Einzelhandelsketten & E-Commerce-Verkäufer",
  aboutBuyerScenario2Body: "Wir unterstützen marktreife Sortimente, Private-Label-Verpackungen und praktikable Kommunikation für wiederholbare Aufträge.",
  aboutBuyerScenario3Title: "Für Marken mit Produkterweiterung",
  aboutBuyerScenario3Body: "Wir fungieren als Koordinationsschicht zwischen Ihrem Konzept, der Produktionsseite und der Exportumsetzung, damit interne Teams schneller vorankommen.",
  aboutWorkflowTitle: "So ist unser Workflow aufgebaut",
  aboutWorkflowStep1: "Anforderungsaufnahme und Klärung des Zielprodukts",
  aboutWorkflowStep2: "Lieferanten-Matching, Angebot und Musterplanung",
  aboutWorkflowStep3: "Prüfung von Spezifikation, Verpackung und Compliance",
  aboutWorkflowStep4: "Produktions-Follow-up, Prüfung und Versandbereitschaft",
  aboutWhyIntegratorTitle: "Warum Käufer einen Lieferketten-Integrator nutzen",
  aboutWhyIntegratorBody1: "Wenn die Beschaffung mehrere Lieferanten, Verpackungspartner und Versandzeitpläne umfasst, liegt das größte Risiko meist nicht im ersten Angebot. Es entsteht, wenn die Abstimmung verloren geht, sobald der Auftrag in Bewegung kommt.",
  aboutWhyIntegratorList1: "Spezifikationen können zwischen Angebot und Produktion abweichen.",
  aboutWhyIntegratorList2: "Verpackungs- und Branding-Details können sich durch fragmentierte Kommunikation verzögern.",
  aboutWhyIntegratorList3: "Prüfung, Dokumentation und Versandvorbereitung können sich vom ursprünglichen kommerziellen Versprechen lösen.",
  aboutWhyIntegratorBody2: "Unser Mehrwert besteht darin, diese Teile verbunden zu halten. Wir arbeiten als Koordinationsschicht zwischen den Erwartungen des Käufers und der Umsetzung durch den Lieferanten, sodass Entscheidungen dokumentiert, Zeitpläne nachverfolgt und Übergaberisiken reduziert werden.",
  aboutTalkToTeam: "Mit unserem Team sprechen",
  aboutPositioningTitle: "Unsere Positionierung",
  aboutPositioningBody: "LOYA SPORT positioniert sich als Lieferketten-Integrator für exportorientierte Fitnessprodukte. Wir helfen Kunden, mit klarerer Koordination, besserer Lieferantenorganisation und einem besser beherrschbaren Weg von der Beschaffung bis zum Versand einzukaufen.",

  solutionsHeroKicker: "Lösungen",
  solutionsHeroTitle: "Wählen Sie den richtigen Beschaffungsweg für Ihren Käufertyp",
  solutionsHeroBody: "Konzipiert als visueller Leitfaden für Kanal-Fit, Szenario-Fit und Produktprogramm-Planung.",
  solutionsTalkToSales: "Mit dem Vertrieb sprechen",
  solutionsBrowseProducts: "Produkte durchsuchen",
  solutionsHeroImageAlt: "B2B-Beschaffungslösungen für Käufer von Yoga- und leichter Fitnessausstattung",
  solutionsHeroBadgeTitle: "Lösungs-Fit",
  solutionsHeroBadgeBody: "Käufertyp + Anwendungsfall + Sortiment",
  solutionsBuyerTypeTitle: "Lösungen nach Käufertyp",
  solutionsViewMatchingProducts: "Passende Produkte anzeigen",
  solutionsScenarioPlansTitle: "Szenario-Pläne",
  solutionsProgramMixesTitle: "Empfohlene Programmmischungen",
  solutionsNextStepKicker: "Nächster Schritt",
  solutionsNextStepTitle: "Benötigen Sie eine maßgeschneiderte Mischung für Ihren Markt?",
  solutionsNextStepBody: "Teilen Sie uns Ihren Käufertyp, die Zielprodukte und den Zielmarkt mit. Wir schlagen Ihnen einen praktikablen Sortimentsweg vor.",
  solutionsRequestPlan: "Lösungsplan anfragen",
  solutionsExploreOem: "OEM-Support entdecken",
  solutionsBuyerCard1Title: "Großhändler",
  solutionsBuyerCard1Subtitle: "Schneller Sortimentsaufbau für Mengenprogramme.",
  solutionsBuyerCard1Need1: "Benötigen eine stabile Mengenversorgung mit geringerem Out-of-Stock-Risiko",
  solutionsBuyerCard1Need2: "Benötigen kartonfertige SKU-Mischungen zur schnelleren Weitervermarktung",
  solutionsBuyerCard1Need3: "Benötigen wiederkehrende Nachbestellzyklen mit planbarer Lieferzeit",
  solutionsBuyerCard1Tag1: "Mengensortimente",
  solutionsBuyerCard1Tag2: "Kartonfertige Packs",
  solutionsBuyerCard1Tag3: "Wiederholte Nachversorgung",
  solutionsBuyerCard2Title: "Einzelhändler",
  solutionsBuyerCard2Subtitle: "Regalfertige Packs und zuverlässige Nachversorgung.",
  solutionsBuyerCard2Need1: "Benötigen klare Preisstufen von Einstiegs- bis Premiumsegment",
  solutionsBuyerCard2Need2: "Benötigen barcodefähige Verpackungen für schnellere Regalplatzierung",
  solutionsBuyerCard2Need3: "Benötigen verlässliche Nachversorgung für schnell drehende Artikel",
  solutionsBuyerCard2Tag1: "Retail-Packs",
  solutionsBuyerCard2Tag2: "Barcode-Support",
  solutionsBuyerCard2Tag3: "Display-freundliche Mischungen",
  solutionsBuyerCard3Title: "Fitnessmarken",
  solutionsBuyerCard3Subtitle: "Private-Label-Programme für Markenexpansion.",
  solutionsBuyerCard3Need1: "Benötigen individuelles Branding, ohne die gesamte Lieferkette neu aufzubauen",
  solutionsBuyerCard3Need2: "Benötigen Verpackungsstile passend zur Markenpositionierung",
  solutionsBuyerCard3Need3: "Benötigen kürzere Zeit von Muster bis Markteinführung",
  solutionsBuyerCard3Tag1: "Logo-Anbringung",
  solutionsBuyerCard3Tag2: "Individuelle Verpackung",
  solutionsBuyerCard3Tag3: "Markenlinenerweiterung",
  solutionsBuyerCard4Title: "Yoga-Studios",
  solutionsBuyerCard4Subtitle: "Studio-Kits, Hilfsmittel und Kurs-Bundles.",
  solutionsBuyerCard4Need1: "Benötigen Starter-Kits für neue Mitglieder und Probekurse",
  solutionsBuyerCard4Need2: "Benötigen langlebige Hilfsmittel für hochfrequente Einheiten",
  solutionsBuyerCard4Need3: "Benötigen praktikable Bundle-Preise für Upsell-Programme",
  solutionsBuyerCard4Tag1: "Starter-Sets",
  solutionsBuyerCard4Tag2: "Kurs-Hilfsmittel",
  solutionsBuyerCard4Tag3: "Mitglieder-Upgrade-Kits",
  solutionsBuyerCard5Title: "Amazon-Verkäufer",
  solutionsBuyerCard5Subtitle: "Marketplace-fertige Bundles und Verpackungen.",
  solutionsBuyerCard5Need1: "Benötigen kompakte Bundle-Strukturen zur Kontrolle der Versandkosten",
  solutionsBuyerCard5Need2: "Benötigen listingtaugliche Produktkombinationen zur Conversion-Steigerung",
  solutionsBuyerCard5Need3: "Benötigen Verpackungsqualität, die die Rücksendequote senkt",
  solutionsBuyerCard5Tag1: "Kompakte Bundles",
  solutionsBuyerCard5Tag2: "Bildtaugliche Verpackung",
  solutionsBuyerCard5Tag3: "Reibungsarme Launches",
  solutionsBuyerCard6Title: "E-Commerce-Unternehmen",
  solutionsBuyerCard6Subtitle: "Visuell starke Produkte für wiederkehrende Online-Verkäufe.",
  solutionsBuyerCard6Need1: "Benötigen Hero-SKUs, die in Anzeigen und Social Traffic gut performen",
  solutionsBuyerCard6Need2: "Benötigen flexible Bundles zur Erhöhung des durchschnittlichen Bestellwerts",
  solutionsBuyerCard6Need3: "Benötigen schnelle Katalogaktualisierungen für saisonale Kampagnen",
  solutionsBuyerCard6Tag1: "Hero-Produkte",
  solutionsBuyerCard6Tag2: "Bundle-Logik",
  solutionsBuyerCard6Tag3: "Schnelle Katalogerneuerung",
  solutionsScenario1Title: "Studio-Starter-Sets",
  solutionsScenario1Body: "Launch-fertige Yoga-Bundles für Kurse, Testangebote und Mitgliederpakete.",
  solutionsScenario2Title: "Recovery- & Massage-Zonen",
  solutionsScenario2Body: "Massage-Tools, Rollen und Recovery-Zubehör für Fitnessstudio-Bereiche.",
  solutionsScenario3Title: "Retail-Display-Programme",
  solutionsScenario3Body: "Ausgewogene Sortimente mit Verpackung für eine ansprechende Regalpräsentation.",
  solutionsScenario4Title: "Online-Bundle-Angebote",
  solutionsScenario4Body: "Kompakte Kits für conversion-orientierte Produktseiten.",
  solutionsProgram1Title: "Studio-Launch-Mix",
  solutionsProgram1Body: "Ein sauberes Starter-Sortiment für kursbasierte Yoga-Geschäfte.",
  solutionsProgram1Item1: "Yoga-Matten",
  solutionsProgram1Item2: "Blöcke & Gurte",
  solutionsProgram1Item3: "Massagezubehör",
  solutionsProgram1SuitedFor: "Studios / Trainer",
  solutionsProgram2Title: "Retail-Regalprogramm",
  solutionsProgram2Body: "Ausgewogene Produktfamilie für Geschäfte mit Bedarf an klaren Preisstufen und Wiederholbestellungen.",
  solutionsProgram2Item1: "Kernmatten",
  solutionsProgram2Item2: "Pilates-Hilfsmittel",
  solutionsProgram2Item3: "Spontane Recovery-Artikel",
  solutionsProgram2SuitedFor: "Einzelhändler / Distributoren",
  solutionsProgram3Title: "Online-Bundle-Paket",
  solutionsProgram3Body: "Kompakte Produktsätze für PDP-Visuals und einfachere Online-Conversion.",
  solutionsProgram3Item1: "Mini-Kits",
  solutionsProgram3Item2: "Geschenkfähige Packs",
  solutionsProgram3Item3: "Private-Label-Beileger",

  solutionsProgram3SuitedFor: "Amazon / E-Commerce",

  contactResponseTitle: "Durchschnittliche Reaktionszeit",
  contactResponseDesc: "Innerhalb von 8 Geschäftsstunden bei Standard-RFQ-Anfragen.",

  carouselLoadingTitle: "Bannerbilder werden geladen",
  carouselLoadingBody: "Wir bereiten die Startseiten-Visuals für Sie vor. Bitte warten Sie einen Moment, während die Bannerbilder geladen werden.",
  carouselPlaceholderTitle: "Bannerbilder werden vorbereitet",
  carouselPlaceholderBody: "Das Startseiten-Karussell erscheint hier, sobald die Bildressourcen bereit sind.",

  aboutProductDev: "Produktentwicklung",
  aboutProductDevDesc: "Schnelle Musterzyklen und praxisnahe Designzusammenarbeit für einen schnelleren Markteintritt.",
  aboutSupplyReliability: "Lieferzuverlässigkeit",
  aboutSupplyReliabilityDesc: "Stabile Materialbeschaffung und Kapazitätsplanung, damit Lieferungen auch in Hochsaisons planmäßig bleiben.",
  aboutTradeSupport: "Liefer- & After-Sales-Support",
  aboutTradeSupportDesc: "Dokumentation, Versandkoordination und After-Sales-Support für reibungslosere internationale Abläufe.",
  aboutSupplyList1: "Verifizierte Lieferantenkoordination für Yoga- und leichte Fitnesslinien",
  aboutSupplyList2: "Mehrstufige Qualitätsprüfung mit Partnerfabriken",
  aboutSupplyList3: "Private-Label- und Verpackungssupport",
  aboutSupplyList4: "Globale Versorgung über wichtige Regionen und Kanäle hinweg",

  oemCapability1: "Individueller Logodruck, Prägung und Lasermarkierung für zentrale Yoga-Accessoires.",
  oemCapability2: "Anpassungen von Farbe, Material, Oberfläche und Größe passend zu Ihrem Zielmarkt.",
  oemCapability3: "Regalfertige Verpackungen, Einlegekarten, Barcode-Etiketten und Kartonmarkierungen.",
  oemCapability4: "Bundle-Entwicklung für Studio-Sets, Amazon-fertige Packs und saisonale Aktionen.",
  oemProcess1Title: "Teilen Sie uns Ihre Idee mit",
  oemProcess1Body: "Senden Sie Zielprodukte, Logodateien, Referenzbilder, Verpackungserwartungen und die geschätzte Menge.",
  oemProcess2Title: "Spezifikationen und MOQ bestätigen",
  oemProcess2Body: "Wir prüfen Materialoptionen, Branding-Methode, Compliance-Punkte, Lieferzeit und eine praktikable Startmenge.",
  oemProcess3Title: "Muster und Überarbeitung",
  oemProcess3Body: "Wir organisieren Muster oder Mockups, sammeln Ihr Feedback und fixieren den Produktionsstandard vor der Anzahlung.",
  oemProcess4Title: "Massenproduktion und Prüfung",
  oemProcess4Body: "Die Produktion erfolgt nach dem freigegebenen Muster, mit Verpackungsprüfungen und Qualitätskontrolle vor dem Versand.",

  news1Title: "Frühjahrs-Beschaffungsleitfaden veröffentlicht",
  news1Body: "Entdecken Sie die neuesten Trends bei Yoga-, Pilates- und Recovery-Produkten für die kommende Verkaufssaison.",
  news2Title: "OEM-Verpackungs-Updates",
  news2Body: "Wir unterstützen jetzt mehr umweltfreundliche Karton-, Einlegekarten- und Barcode-Verpackungsoptionen für Private-Label-Programme.",
  news3Title: "Hinweis zum Exportzeitplan",
  news3Body: "Lieferzeitplanung und Versandfenster werden wöchentlich aktualisiert, damit Käufer Launch-Kalender präziser steuern können.",

  navYogaMats: "Yoga-Matten",
  navYogaBlocks: "Yoga-Blöcke",
  navYogaStraps: "Yoga-Gurte",
  navResistanceBands: "Widerstandsbänder",
  navPilatesRings: "Pilates-Ringe",
  navFoamRollers: "Schaumstoffrollen",
  navOemPrivateLabel: "Individueller Service",
  navSolutionsControl: "Lösungen",
  navBlog: "Blog",
  navCompanyProfile: "Über uns",
  navContactUs: "Kontakt",
  seeAllCategories: "Alle Kategorien anzeigen",

  productDetailReady: "Private-Label-fertig",
  productDetailQuote: "Preis auf Anfrage",
  productDetailViewSpecs: "Spezifikationen anzeigen",
  productDetailRequestQuote: "Angebot anfragen",

  pdLoadErrorProductDetail: "Produktdetail konnte nicht geladen werden",
  pdLoadErrorRelatedProducts: "Ähnliche Produkte konnten nicht geladen werden",
  pdLoadErrorStorefrontConfig: "Storefront-Konfiguration konnte nicht geladen werden",
  pdLoading: "Produktdetail wird geladen...",
  pdSampleDefaultMessage: "Bitte teilen Sie uns Musterpolitik, Lieferzeit und Angebotsdetails mit.",
  pdAttrProductName: "Produktname",
  pdAttrModelNo: "Modell-Nr.",
  pdAttrCategory: "Kategorie",
  pdAttrManufacturer: "Hersteller",
  pdLeadTimeOnRequest: "Lieferzeit auf Anfrage",
  pdLeadTimeUpTo: "Bis zu {qty} Stk.: {days} Tage",
  pdLeadTimeFrom: "{qty}+ Stk.: {days} Tage",
  pdLeadTimeDaysOnly: "{days} Tage",
  pdContactForQuote: "Für Angebot kontaktieren",
  pdPerPiece: "{price} / Stück",
  pdAnonymousBuyer: "Anonymer Käufer",
  pdReviewTipSignIn: "Bitte als Kunde anmelden, um als hilfreich zu stimmen.",
  pdReviewTipSessionExpired: "Sitzung abgelaufen. Bitte erneut anmelden, um abzustimmen.",
  pdReviewTipNoPermission: "Das aktuelle Konto darf nicht als hilfreich abstimmen.",
  pdReviewTipUpdateFailed: "Hilfreich-Status konnte nicht aktualisiert werden",
  pdSpecValues: "Werte",
  pdSpecRequired: "Erforderlich",
  pdSpecOptional: "Optional",
  pdCapabilityCustomLogo: "Individuelle Logo-Anbringung",
  pdCapabilitySampleDev: "Musterbasierte Entwicklung",
  pdCapabilityPackagingCoordination: "Verpackungskoordination",
  pdCapabilityExportFollowUp: "Export- und Versandnachverfolgung",
  pdPackagingSellingUnit: "Verkaufseinheit",
  pdPackagingSingleItem: "Einzelartikel",
  pdPackagingType: "Verpackung",
  pdPackagingTypeFallback: "OPP-Beutel / Exportkarton",
  pdPackagingLoadingAdvice: "Ladehinweis",
  pdPackagingLoadingAdviceFallback: "Abhängig von der Auftragsstruktur",
  pdPackagingLeadTime: "Lieferzeit",
  pdMediaPhotoLabel: "Foto {index}",
  pdMediaVideoLabel: "Video",
  pdMediaAttributesLabel: "Eigenschaften",
  pdPackagingPointPackaging: "Verpackung: {value}",
  pdPackagingPointLoadingAdvice: "Ladehinweis: {value}",
  pdPackagingPointShippingPort: "Versandhafen: {value} (verhandelbar)",
  pdPackagingPointShippingPortNegotiable: "Versandhafen: verhandelbar",
  pdPackagingPointLeadTime: "Lieferzeit: {value}",
  pdInquiryHello: "Hallo, ich möchte anfragen zu:",
  pdInquiryProduct: "Produkt: {value}",
  pdInquirySku: "SKU: {value}",
  pdInquirySkuName: "SKU-Name: {value}",
  pdInquiryModel: "Modell: {value}",
  pdInquiryQuantity: "Menge: {value}",
  pdEmailSubject: "Anfrage: {sku} - {name}",
  pdInquirySubmitFailed: "Anfrage kann derzeit nicht gesendet werden.",
  pdSampleContactPerson: "Kontaktperson: {value}",
  pdSampleWhatsapp: "WhatsApp/WeChat: {value}",
  pdSampleCompany: "Unternehmen: {value}",
  pdSampleRequestedQuantity: "Angefragte Menge: {value}",
  pdSampleSelectorQuantity: "Mengenwahl auf der Seite: {value}",
  pdVariationLabel: "Option",
  pdVariationInquiryIntro: "Hallo, ich möchte eine Anfrage senden für:",
  pdVariationInquiryQuoteLeadTime: "Bitte teilen Sie das aktuelle Angebot und die Lieferzeit mit.",
  pdVideoFallback: "Video konnte nicht geladen werden. Bitte erneut versuchen oder die Quelle direkt öffnen.",
  pdRetry: "Erneut versuchen",
  pdOpenVideoUrl: "Video-URL öffnen",
  pdProductAttributes: "Produkteigenschaften",
  pdMediaTabsAria: "Produktmedientypen",
  pdMediaTabPhotos: "Fotos",
  pdMediaTabVideo: "Video",
  pdMediaTabAttributes: "Eigenschaften",
  pdInfoTabsAria: "Tabs mit Detailinformationen",
  pdInfoTabAttributes: "Eigenschaften",
  pdInfoTabDescription: "Beschreibung",
  pdInfoTabSupplier: "Lieferant",
  pdInfoTabReviews: "Bewertungen",
  pdKeyAttributes: "Wichtige Merkmale",
  pdPackagingShippingInfo: "Verpackungs- und Versandinformationen",
  pdProductDescription: "Produktbeschreibung",
  pdSupplierOverview: "Lieferantenübersicht",
  pdSupplierOverviewHint: "Unternehmensprofil und FAQ werden unterhalb der Detailbilder angezeigt.",
  pdBuyerFeedback: "Kundenfeedback",
  pdRepeatBuyer: "Wiederkehrender Käufer",
  pdReviewRatingAria: "Bewertung {rating} von 5",
  pdReviewMetaColor: "Farbe: {value}",
  pdReviewMetaColorFallback: "zweite",
  pdReviewUnavailable: "Dieses Produkt ist nicht mehr verfügbar",
  pdReviewHelpful: "Hilfreich ({count})",
  pdNoReviews: "Noch keine Bewertungen für dieses Produkt.",
  pdNoReviewsHint: "Kontaktieren Sie unser Team für Bestellreferenzen oder Musterfeedback.",
  pdTitleFallback: "Produktdetail",
  pdCustomizable: "Anpassbar",
  pdVariationCardAria: "Produktvarianten",
  pdVariations: "Varianten",
  pdSelectNow: "Jetzt wählen",
  pdSelectOption: "Option wählen",
  pdLadderPricingAria: "Staffelpreise",
  pdProductSpecifications: "Produktspezifikationen",
  pdSpecPrevAria: "Vorherigen Spezifikationswert anzeigen",
  pdSpecNextAria: "Nächsten Spezifikationswert anzeigen",
  pdSupplierCapability: "Anpassungsfähigkeit des Lieferanten",
  pdGetFreeSample: "Kostenloses Muster erhalten",
  pdWhatsAppInquiry: "WhatsApp-Anfrage",
  pdEmailInquiry: "E-Mail-Anfrage",
  pdPackagingDelivery: "Verpackung & Lieferung",
  pdProductVideo: "Produktvideo",
  pdVideoOpenLink: "Das Video kann im aktuellen Kontext nicht abgespielt werden.",
  pdSupplierDescriptions: "Produktbeschreibungen vom Lieferanten",
  pdCompanyIntroduction: "Unternehmensvorstellung",
  pdNoCompanyIntroduction: "Keine Unternehmensvorstellung konfiguriert.",
  pdFaq: "FAQ",
  pdNoFaq: "Keine FAQ konfiguriert.",
  pdCloseVariationSelector: "Variantenauswahl schließen",
  pdVariationSelectAndQty: "Varianten und Menge auswählen",
  pdVariationStock: " / Bestand {count}",
  pdSelectedQuantity: "Ausgewählte Menge",
  pdSendInquiry: "Anfrage senden",
  pdChatNow: "Jetzt chatten",
  pdOptionLabel: "Option {index}",
  pdRelatedAria: "Ähnliche Produkte",
  pdRelatedTitle: "Ähnliche Produkte",
  pdRelatedSubtitle: "Weitere Artikel, die in dieser Kategorie häufig zusammen beschafft werden.",
  pdRelatedPrevAria: "Vorherige ähnliche Produkte",
  pdRelatedNextAria: "Nächste ähnliche Produkte",
  pdSampleContactTitle: "Bitte kontaktieren Sie uns",
  pdSampleContactDesc: "Fragen? Wir helfen gerne. Kontaktieren Sie uns per WhatsApp oder E-Mail für Mustersupport.",
  pdSampleCloseAria: "Musteranfrage schließen",
  pdSampleSummaryProduct: "Produkt",
  pdSampleSummaryQuantity: "Menge",
  pdFormFullName: "Vollständiger Name",
  pdFormFullNamePlaceholder: "Ihr Name",
  pdFormEmail: "E-Mail*",
  pdFormEmailPlaceholder: "Kontakt per E-Mail",
  pdFormWhatsapp: "WhatsApp/WeChat*",
  pdFormWhatsappPlaceholder: "Kontakt per WhatsApp",
  pdFormCompany: "Ihr Firmenname",
  pdFormCompanyPlaceholder: "Ihr Firmenname",
  pdFormRequiredQuantity: "Benötigte Menge",
  pdFormRequiredQuantityPlaceholder: "Benötigte Muster- oder Testmenge",
  pdFormMessage: "Nachricht",
  pdFormMessagePlaceholder: "Bitte beschreiben Sie Ihre Produktanforderungen kurz",
  pdFormSending: "Wird gesendet...",
  pdFormSendMessage: "Nachricht senden",
  pdFormInquirySuccess: "Anfrage erfolgreich übermittelt.",

  oemHeroKicker: "Individueller Service",
  oemTitle: "Bauen Sie eine individuelle Yoga-Linie mit klarem Produktionsworkflow auf",
  oemIntro: "Wir unterstützen internationale Käufer bei Produktanpassung, Verpackungsentwicklung, Muster-Follow-up und Auftragsumsetzung in den Kategorien Yoga und leichte Fitness.",
  oemStartProject: "Individuelles Projekt starten",
  oemBrowseProducts: "Basisprodukte durchsuchen",
  oemVisualGuide: "Visueller Individualisierungsleitfaden",
  oemVisualAlt: "OEM-Individualisierungsoptionen und Prozessleitfaden",
  oemVisualPlaceholder: "Individualisierungsbild nicht gefunden. Bitte fügen Sie Ihren Anhang unter frontend/public/assets/about/oem-customization-guide.jpg hinzu.",
  oemCapabilityKicker: "Was wir individualisieren können",
  oemCapabilityTitle: "Von der Logo-Anbringung bis zur vollständigen Verpackungsumsetzung",
  oemProjectBrief: "Projektbrief",
  oemServiceShowcaseAria: "OEM- und ODM-Individualisierungsservices",
  oemServiceShowcaseTitle: "OEM- & ODM-Individualisierungsservices",
  oemServiceShowcaseBody: "Flexibler One-Stop-Support von der Konzeptprüfung bis zur Produktion und Versandübergabe.",
  oemCompareHeadBody: "Vier typische Wege, dargestellt als Basisprodukt versus individualisiertes Ergebnis.",
  oemCompareBaseSuffix: "Basisversion",
  oemCompareOptionsSuffix: "Individualisierungsoptionen",
  oemCompareCustomizedSuffix: "individualisierte Version",
  oemCompare1Title: "Logo-Anbringung",
  oemCompare1Body: "Vom schlichten Produkt zur Markenpräsentation.",
  oemCompare1BeforeLabel: "Basis",
  oemCompare1AfterLabel: "Mit Logo",
  oemCompare1CustomizationLabel: "Logo-Ergänzung",
  oemCompare1Item1: "Druck",
  oemCompare1Item2: "Prägung",
  oemCompare1Item3: "Lasermarkierung",
  oemCompare2Title: "Farbe und Finish",
  oemCompare2Body: "Von neutraler Spezifikation zur markttauglichen Farbvariante.",
  oemCompare2BeforeLabel: "Standard",
  oemCompare2AfterLabel: "Individuelle Farbe",
  oemCompare2CustomizationLabel: "Farbupdate",
  oemCompare2Item1: "Farbe",
  oemCompare2Item2: "Textur",
  oemCompare2Item3: "Größe",
  oemCompare3Title: "Verpackungsaufbau",
  oemCompare3Body: "Von schlichter Verpackung zur regalfertigen Präsentation.",
  oemCompare3BeforeLabel: "Schlichte Verpackung",
  oemCompare3AfterLabel: "Regalfertig",
  oemCompare3CustomizationLabel: "Packungsdetails",
  oemCompare3Item1: "Einlegekarte",
  oemCompare3Item2: "Barcode",
  oemCompare3Item3: "Kartonmarkierung",
  oemCompare4Title: "Bundle-Entwicklung",
  oemCompare4Body: "Von Einzelartikeln zum kanalreifen Set.",
  oemCompare4BeforeLabel: "Einzelartikel",
  oemCompare4AfterLabel: "Bundle-Set",
  oemCompare4CustomizationLabel: "Bundle-Logik",
  oemCompare4Item1: "Studio-Set",
  oemCompare4Item2: "Amazon-Pack",
  oemCompare4Item3: "Promo-Mix",
  oemCasesTitle: "Individualisierungsfälle",
  oemCase1Title: "Boutique-Studio-Starterlinie",
  oemCase1Summary: "Starter-Kit-Präsentation für den Launch eines Boutique-Studios.",
  oemCase1Details: "Logo-fertiges Bundle in 12 Tagen freigegeben.",
  oemCase2Title: "Private-Label-Refresh für den Einzelhandel",
  oemCase2Summary: "Aktualisierter Verpackungslook für eine sauberere Regalpräsentation.",
  oemCase2Details: "Schnellere Käuferfreigabe und stärkere Retail-Konsistenz.",
  oemCase3Title: "Marketplace-fertiges Fitness-Bundle",
  oemCase3Summary: "Bundle-Aufbau vorbereitet für E-Commerce und Listing-Einsatz.",
  oemCase3Details: "Einleger, Barcode und Bulk-Produktionsprüfung vorbereitet.",
  oemOrderingFlowKicker: "Bestellablauf",
  oemOrderingFlowTitle: "Kontakt und Bestellung in fünf Schritten",
  oemContactFlow1: "Erstanfrage mit Produktliste, Zielmarkt und Branding-Wunsch.",
  oemContactFlow2: "Angebot mit Musterplan, Lieferzeit und Verpackungsoptionen.",
  oemContactFlow3: "Musterfreigabe und Bestelldetails bestätigen.",
  oemContactFlow4: "Anzahlung, Produktion, Prüfung und Versandbuchung.",
  oemContactFlow5: "Restzahlung, Exportdokumente und After-Sales-Follow-up.",
  oemContactSideTitle: "Bereit, Ihre OEM-Anfrage zu besprechen?",
  oemContactSideBody: "Senden Sie Ihr Logo, Zielmenge und Verpackungsidee. Wir antworten mit einem praktikablen Angebotsweg und einer Mustersuggestion.",
  oemContactSideNote: "Bevorzugter Erstkontakt: E-Mail oder Anfrageformular mit Artwork und gewünschtem Versandzeitfenster.",
  oemContactSideCta: "Vertriebsteam kontaktieren",

  newsHeroKicker: "Branchen-Updates",
  newsTitle: "News & Updates",
  newsIntro: "Verfolgen Sie unsere neuesten Beschaffungs-Insights, Produktlaunch-Hinweise und Export-Updates für Käufer von Fitnesszubehör.",
  newsSectionTitle: "Für Ankündigungen zu Individualprojekten oder Vorschauen neuer Kollektionen kontaktieren Sie bitte unser Vertriebsteam für den aktuellen Katalog.",

  contactTitle: "Lieferanten kontaktieren",
  contactHeroKicker: "Geschäftsanfrage",
  contactIntro: "Teilen Sie uns Ihre Produktanforderungen und Ihren Zielmarkt mit. Unser Team antwortet mit Angebotsdetails und Schätzungen zur Lieferzeit.",
  contactFormTitle: "Anfrage senden",
  contactName: "Ihr Name",
  contactEmail: "Geschäftliche E-Mail",
  contactCompany: "Firmenname",
  contactMessage: "Produktspezifikationen, Menge, Versandziel",
  contactSubmit: "Anfrage senden",
  contactSent: "Nachricht erfolgreich übermittelt.",
  contactInfoTitle: "Vertriebsbüro",
  contactInfoEmail: "E-Mail",
  contactInfoPhone: "Telefon",
  contactInfoHours: "Arbeitszeiten: Mo-Sa, 09:00-18:00 (GMT+8)",
  contactInfoNote: "Bevorzugte Kanäle: E-Mail für formelle Angebote, Telefon für dringende Bestellterminbestätigungen.",
  contactInquiryGreeting: "Hallo, ich möchte dieses Produkt anfragen:",
  contactInquiryProductPrefix: "Produkt:",
  contactInquiryQuantity: "Menge:",
  contactInquiryDestinationPort: "Zielhafen:",

  aboutTitle: "Über LOYA SPORT",
  aboutIntro: "LOYA SPORT ist ein Lieferketten-Integrator für Yoga-Produkte und bedient globale B2B-Käufer.",
  aboutWhoWeAre: "Wer wir sind",
  aboutWhoWeAreDesc1: "Wir unterstützen Importeure, Distributoren, Einzelhändler und Private-Label-Marken, indem wir Beschaffung, Muster, Branding und Versand-Follow-up mit verifizierten Versorgungspartnern koordinieren.",
  aboutWhoWeAreDesc2: "Unsere Stärke liegt in praxisnaher Kommunikation, Kategorienfokus und einem klaren Einkaufsworkflow, der internationalen Kunden hilft, schneller voranzukommen.",
  aboutSupplyCapabilities: "Beschaffungskompetenzen",
  aboutMission: "Unsere Mission",
  aboutMissionDesc: "Fitnessmarken und Einzelhandelskäufern durch verlässliche Beschaffung, strenge Qualitätskontrolle und umfassenden After-Sales-Support beim Wachstum zu helfen.",

  navHome: "Startseite",
  navProducts: "Produkte",
  navCustomization: "Individueller Service",
  navSolutions: "Lösungen",
  navAbout: "Über uns",
  navContact: "Kontakt",

  btnContactUs: "Kontakt",
  btnLogin: "Anmelden",
  btnAccount: "Konto",
  btnQuote: "Angebot anfragen",
  btnCurrency: "Währung",
  btnLanguage: "Sprache",

  requestQuote: "Angebot anfragen",
  trustTitle: "Globale Partner & Vertrauen",
  factoryStatsSize: "30.000 m² Fabrikfläche",
  factoryStatsQC: "100 % vollständige Qualitätsprüfung während und nach der Produktion",
  homeAriaTrust: "Bereich Vertrauen und Partner",
  homeAriaStats: "Fabrikkennzahlen und Statistiken",

  authLogin: {
    welcomeBack: "Willkommen zurück",
    brandIntro: "Melden Sie sich an, um Yoga- und Fitnessprodukte weiter zu beschaffen.",
    brandBullet1: "Schneller RFQ-Workflow",
    brandBullet2: "Produkt- und Auftragsnachverfolgung",
    brandBullet3: "B2B-Konto-Support",
    accountLogin: "Konto-Anmeldung",
    createAccount: "Konto erstellen",
    recoverPassword: "Passwort zurücksetzen",
    registrationComplete: "Registrierung abgeschlossen",
    passwordUpdated: "Passwort aktualisiert",
    loginDesc: "Melden Sie sich mit Benutzername oder E-Mail und Passwort an.",
    registerDesc: "Erstellen Sie ein Konto mit Benutzername, E-Mail-Verifizierung und Captcha.",
    forgotDesc: "Geben Sie Ihre Konto-E-Mail ein, um einen Reset-Code zu erhalten.",
    registerSuccessDesc: "Ihr Konto wurde erfolgreich erstellt. Wir wechseln automatisch zur Login-Ansicht.",
    resetSuccessDesc: "Ihr Passwort wurde erfolgreich aktualisiert. Wir wechseln automatisch zur Login-Ansicht.",
    redirectHintPrefix: "Die Seite wechselt in",
    redirectHintSuffix: "zum Login-Bildschirm.",
    seconds: "Sekunden",
    loginNow: "Jetzt anmelden",
    username: "Benutzername",
    usernamePlaceholder: "Mindestens 3 Zeichen, z. B. loya_buyer",
    usernameHelp: "Der Benutzername muss mindestens 3 Zeichen lang sein, darf keine reservierten Wörter enthalten und nur Buchstaben, Zahlen, Unterstriche und Bindestriche verwenden.",
    usernameExistsHint: "Dieser Benutzername ist bereits registriert. Melden Sie sich direkt an oder wählen Sie einen anderen.",
    usernameExists: "Benutzername existiert bereits. Bitte wählen Sie einen anderen oder melden Sie sich direkt an.",
    usernameExistsAction: "Benutzername vorhanden, zum Login",
    usernameAlreadyRegistered: "Dieser Benutzername ist bereits registriert.",
    usernameAvailable: "Benutzername ist verfügbar.",
    usernameVerifyFailed: "Benutzername kann derzeit nicht geprüft werden. Bitte versuchen Sie es erneut.",
    checkingUsername: "Benutzername wird geprüft...",
    email: "E-Mail",
    emailPlaceholder: "ihre@email.com",
    emailCodeTargetHint: "Geben Sie die E-Mail-Adresse ein, über die Sie den Verifizierungscode erhalten möchten.",
    emailExistsHint: "Diese E-Mail ist bereits registriert. Melden Sie sich direkt an oder verwenden Sie eine andere E-Mail.",
    emailExists: "E-Mail existiert bereits. Bitte verwenden Sie eine andere oder gehen Sie zum Login.",
    emailExistsAction: "E-Mail vorhanden, zum Login",
    emailAlreadyRegistered: "Diese E-Mail ist bereits registriert.",
    emailAvailable: "E-Mail ist verfügbar.",
    emailVerifyFailed: "E-Mail kann derzeit nicht geprüft werden. Bitte versuchen Sie es erneut.",
    checkingEmail: "E-Mail wird geprüft...",
    usernameOrEmail: "Benutzername oder E-Mail",
    usernameOrEmailPlaceholder: "Benutzername oder ihre@email.com",
    forgotEmailHint: "Geben Sie die mit Ihrem Konto verknüpfte E-Mail ein, damit wir einen Reset-Code senden können.",
    password: "Passwort",
    passwordPlaceholder: "Passwort eingeben",
    confirmPassword: "Passwort bestätigen",
    confirmPasswordPlaceholder: "Passwort erneut eingeben",
    confirmNewPassword: "Neues Passwort bestätigen",
    confirmNewPasswordPlaceholder: "Neues Passwort erneut eingeben",
    nickname: "Spitzname",
    nicknamePlaceholder: "Optional, für die Anzeige",
    captcha: "Captcha",
    registerCaptcha: "Registrierungs-Captcha",
    resetCaptcha: "Reset-Captcha",
    refreshCaptcha: "Captcha aktualisieren",
    load: "Laden",
    forgotCaptchaHint: "Captcha zuerst ausfüllen, dann den Passwort-Reset-Code anfordern. Danach wird automatisch ein neues Captcha geladen.",
    registerCaptchaHint: "Captcha zuerst ausfüllen, dann den E-Mail-Verifizierungscode anfordern.",
    registerStepHint: "Zuerst Benutzername, Passwort, Passwortbestätigung und gültige E-Mail ausfüllen. Danach erscheint der Captcha- und E-Mail-Code-Bereich.",
    emailCode: "E-Mail-Code",
    emailCodePlaceholder: "6-stelliger Code",
    resetCode: "Reset-Code",
    resetCodePlaceholder: "6-stelliger Reset-Code",
    sending: "Wird gesendet...",
    resendIn: "Erneut senden in",
    sendEmailCode: "E-Mail-Code senden",
    sendResetCode: "Reset-Code senden",
    signingIn: "Anmeldung läuft...",
    login: "Anmelden",
    updating: "Wird aktualisiert...",
    creating: "Wird erstellt...",
    resetPassword: "Passwort zurücksetzen",
    forgotRequirementHint: "Zur Passwortwiederherstellung sind Captcha-Verifizierung und der per E-Mail gesendete Reset-Code erforderlich.",
    registerRequirementHint: "Für die Registrierung ist der an Ihr Postfach gesendete E-Mail-Code erforderlich.",
    captchaRefreshHint: "Wenn das Captcha schwer lesbar ist, klicken Sie auf das Bild rechts zum Aktualisieren.",
    switchToLogin: "Bereits ein Konto? Jetzt anmelden",
    switchToRegister: "Noch kein Konto? Jetzt registrieren",
    backToLogin: "Zurück zum Login",
    forgotPassword: "Passwort vergessen?",
    usernameRequired: "Geben Sie einen Benutzernamen mit mindestens 3 Zeichen ein.",
    usernameMin: "Der Benutzername muss mindestens 3 Zeichen lang sein.",
    usernameMax: "Der Benutzername darf höchstens 24 Zeichen lang sein.",
    usernamePattern: "Benutzername darf nur Buchstaben, Zahlen, Unterstriche und Bindestriche enthalten.",
    usernameReserved: "Dieser Benutzername ist reserviert. Bitte wählen Sie einen anderen.",
    usernameFormatOk: "Benutzername-Format ist gültig.",
    emailRequired: "Bitte E-Mail-Adresse eingeben.",
    emailInvalid: "Bitte eine gültige E-Mail-Adresse eingeben.",
    emailFormatOk: "E-Mail-Format ist gültig.",
    emailProviderHint: "Verwenden Sie möglichst einen gängigen E-Mail-Anbieter wie Gmail, Outlook, QQ Mail, 163, 126 oder Foxmail.",
    passwordRequired: "Bitte Passwort eingeben.",
    didYouMean: "Meinten Sie",
    passwordMin: "Das Passwort muss mindestens 6 Zeichen haben.",
    newPasswordMin: "Das neue Passwort muss mindestens 6 Zeichen haben.",
    confirmPasswordRequired: "Bitte Passwortbestätigung eingeben.",
    passwordMatch: "Passwörter stimmen überein.",
    passwordMismatch: "Die beiden Passwörter stimmen nicht überein.",
    emailCodeRequired: "Bitte E-Mail-Verifizierungscode eingeben.",
    resetCodeRequired: "Bitte den an Ihre E-Mail gesendeten Reset-Code eingeben.",
    captchaRequired: "Bitte Captcha-Code eingeben.",
    captchaExpired: "Das Captcha ist abgelaufen. Bitte Seite aktualisieren und erneut versuchen.",
    captchaIncorrect: "Der Captcha-Code ist falsch. Bitte erneut versuchen.",
    registerPrerequisitesError: "Benutzername, Passwort, Passwortbestätigung und gültige E-Mail ausfüllen, bevor der E-Mail-Verifizierungscode angefordert wird.",
    enterCaptchaBeforeEmailCode: "Bitte Captcha eingeben, bevor Sie den E-Mail-Verifizierungscode anfordern.",
    enterCaptchaBeforeResetCode: "Bitte Captcha eingeben, bevor Sie den Passwort-Reset-Code anfordern.",
    sendEmailCodeFailed: "E-Mail-Verifizierungscode konnte nicht gesendet werden.",
    emailCodeSent: "Der E-Mail-Verifizierungscode wurde gesendet.",
    emailCodeSentInbox: "Der E-Mail-Verifizierungscode wurde gesendet. Bitte prüfen Sie Ihren Posteingang.",
    previewCodeCurrentEnv: "Vorschaucode für die aktuelle Umgebung",
    previewCodeDevelopment: "Vorschaucode für die Entwicklung",
    previewCodeGenerated: "Der E-Mail-Verifizierungscode wurde generiert. Diese Umgebung verwendet einen Vorschaucode.",
    previewCodeContinueRegistration: "Geben Sie diesen 6-stelligen Code ein, um die Registrierung abzuschließen.",
    tooManyRequests: "Zu viele Anfragen. Bitte später erneut versuchen.",
    smtpConfigRetry: "E-Mail-Versand fehlgeschlagen. Überprüfen Sie die SMTP-Konfiguration und versuchen Sie es erneut.",
    emailServiceNotConfigured: "Der E-Mail-Dienst ist nicht konfiguriert. Bitte kontaktieren Sie den Administrator.",
    requestFailed: "Anfrage fehlgeschlagen. Bitte erneut versuchen oder den Support kontaktieren.",
    registerFailed: "Registrierung fehlgeschlagen",
    resetFailed: "Passwortzurücksetzung fehlgeschlagen",
    loginFailed: "Anmeldung fehlgeschlagen",
    registerSuccessNotice: "Registrierung erfolgreich. Weiterleitung zum Login in etwa 4 Sekunden.",
    resetSuccessNotice: "Passwort erfolgreich zurückgesetzt. Weiterleitung zum Login in etwa 1,5 Sekunden.",
    loginTokenMissing: "Login-Token fehlt",
    profileLoadFailed: "Kontoprofil konnte nicht geladen werden",
    loginSuccessAdmin: "Anmeldung erfolgreich. Weiterleitung...",
    loginSuccessStorefront: "Anmeldung erfolgreich. Weiterleitung zur Storefront...",
    loginServiceUnavailable: "Der Login-Service ist vorübergehend nicht verfügbar. Bitte versuchen Sie es gleich erneut.",
    accountNotFound: "Konto nicht gefunden. Bitte Benutzername oder E-Mail überprüfen.",
    passwordIncorrect: "Falsches Passwort. Bitte erneut versuchen.",
    registrationNotOpen: "Anmeldung und Registrierung sind derzeit geschlossen.",
    accountRestricted: "Dieses Konto ist gesperrt. Bitte Administrator kontaktieren.",
    orContinueWith: "Oder weiter mit",
    googleAuthorizing: "Google-Konto wird autorisiert...",
    googleFallbackAction: "Mit Google fortfahren",
    googleAuthFailed: "Google-Authentifizierung fehlgeschlagen",
    googleAuthOffline: "Google-Anmeldung ist offline vorübergehend nicht verfügbar. Bitte verbinden Sie sich mit dem Internet oder verwenden Sie Benutzername/Passwort.",
    googleAuthTimeout: "Google-Verifizierung abgelaufen. Bitte kurz darauf erneut versuchen. Wenn es weiterhin fehlschlägt, bitten Sie den Administrator, den ausgehenden Netzwerkzugang des Backends zu prüfen.",
    googleAuthNetworkError: "Google-Verifizierung aufgrund eines Backend-Netzwerkfehlers fehlgeschlagen. Bitte Administrator kontaktieren.",
    googleRegisterSuccess: "Google-Konto erfolgreich verknüpft. Weiterleitung zur Storefront...",
    googleCreateAccountTitle: "Google-Registrierung abschließen",
    googleCreateAccountDesc: "Google hat Ihre E-Mail verifiziert. Legen Sie ein Passwort fest, um ein Kundenkonto zu erstellen und die Anmeldung abzuschließen.",
    googleCreateAccountHint: "Für diese Google-E-Mail existiert noch kein Konto. Legen Sie ein Passwort fest, um Ihr Kundenkonto zu erstellen.",
    googleLinkedEmailHint: "Diese verifizierte Google-E-Mail wird verwendet, um Ihr Kundenkonto zu erstellen.",
    googleCreatePasswordHint: "Legen Sie ein Passwort fest und bestätigen Sie es. Das neue Kundenkonto verwendet Ihre Google-verifizierte E-Mail.",
    submitLogin: "Anmelden",
    submitRegister: "Registrieren",
    submitReset: "Passwort zurücksetzen"
  },

  admin: {
    productCategoryYogaMats: "Yoga-Matten",
    productCategoryYogaBlocks: "Yoga-Blöcke",
    productCategoryYogaStraps: "Yoga-Gurte",
    productCategoryResistanceBands: "Widerstandsbänder",
    productCategoryPilatesRings: "Pilates-Ringe",
    productCategoryFoamRollers: "Schaumstoffrollen",
    productCategoryOthers: "Andere",

    faqSampleOrderQ: "Akzeptieren Sie Musterbestellungen?",
    faqSampleOrderA: "Ja, wir akzeptieren Musterbestellungen. Bitte kontaktieren Sie uns gerne.",
    faqCustomPackagingQ: "Bieten Sie individuelle Verpackung und Logo-Service an?",
    faqCustomPackagingA: "Ja, wir bieten kundenspezifische OEM-/ODM-Services an.",
    faqLeadTimeQ: "Wie lang ist Ihre Lieferzeit?",
    faqLeadTimeA: "In der Regel 1 bis 3 Tage je nach Bestellmenge. Die endgültige Lieferzeit wird nach Aufgabe der Bestellung bestätigt.",
    faqDefectiveItemQ: "Wie wird mit defekten Produkten umgegangen?",
    faqDefectiveItemA: "Wir bieten eine einjährige Garantie ab Versanddatum. Wenn innerhalb der Garantiezeit ein Defekt aufgrund unseres Materials oder unserer Verarbeitung auftritt, senden Sie uns bitte Details einschließlich Beschreibung, Bilder oder Video und bei Bedarf auch ein fehlerhaftes Muster. Unsere Ingenieure analysieren den Fall und unterbreiten eine Lösung. Wenn Sie eine Rücksendung wünschen, kontaktieren Sie uns bitte und senden Sie die Produkte mit Originalverpackung und Zubehör zurück. Nach Erhalt der Rücksendung erstatten wir den Betrag oder senden kostenlosen Ersatz.",
    faqWhyChooseUsQ: "Warum sollten Sie uns wählen?",
    faqWhyChooseUsA: "Unsere Produkte bieten niedrige Mindestbestellmengen und hohe Qualität nach US- oder EU-Standards. Wir liefern hochwertigen Service, unterstützen OEM und Trade Assurance. Sie können mit Vertrauen bestellen.",

    companyImageSectionOverview: "Unternehmensübersicht",
    companyImageSectionAdvantages: "Wettbewerbsvorteile",
    companyImageSectionCustomization: "Individualisierungskompetenzen",
    companyImageSectionExtended: "Erweitertes Unternehmensprofil",
    companyImageSectionPackaging: "Verpackungs- und Versandspezifikationen",
    companyImageSectionFactory: "Fabrikprofil",
    companyImageSectionWorkflow: "Produktionsworkflow",
    companyImageSectionTradeShow: "Messeauftritte",

    orderStatusPaid: "Bezahlt",
    orderStatusPacked: "Verpackt",
    orderStatusInTransit: "Unterwegs",
    orderStatusDelivered: "Zugestellt",
    orderStatusCancelled: "Storniert",

    tabDescHome: "Verwalten Sie hier Arbeitsbereichsabläufe und überwachen Sie die Leistung.",
    tabDescStoreBase: "Konfigurieren Sie Frontend-/Admin-Adressen und SEO-Metadaten.",
    tabDescTemplateStudio: "Storefront-Layout-Module visuell bearbeiten und benutzerdefinierte Vorlagen speichern.",
    tabDescArticleManagement: "Verwalten Sie Blogartikel in einem dedizierten Arbeitsbereich mit fensterbasiertem Editor.",
    tabDescCompanyImages: "Verwalten Sie Unternehmensbild-Kategorien für Inhalte des Storefront-Profils.",
    tabDescDesignNav: "Konfigurieren Sie die Frontend-Navigation und verschachtelte Menüstrukturen.",
    tabDescDesignCarousel: "Verwalten Sie Banner des Startseiten-Karussells im Frontend.",
    tabDescDesignBanner: "Konfigurieren Sie Bannerbotschaften und Call-to-Action-Inhalte.",
    tabDescFaqKnowledge: "Pflegen Sie eine FAQ-Wissensdatenbank für Betriebs- und Vertriebsteams.",
    tabDescProducts: "Verwalten Sie Produktkatalog, Details und Preisinformationen.",
    tabDescProductCreate: "Erstellen Sie neue Produkte und vervollständigen Sie alle Informationen und Medien.",
    tabDescMerchandising: "Bewerten Sie Produktkandidaten, Preisstrukturen und Launch-Bereitschaft.",
    tabDescProcurement: "Koordinieren Sie Einkaufspläne, Lieferantenfortschritt und Beschaffungsprioritäten.",
    tabDescQuality: "Verfolgen Sie Qualitätskontrollpunkte und Freigabebereitschaft vor der Ausführung.",
    tabDescLogistics: "Verfolgen Sie Versandstatus, Verpackungsvorbereitung und Logistikkoordination.",
    tabDescOrders: "Verfolgen Sie den vollständigen Bestelllebenszyklus, die Auftragsausführung und Versandupdates.",
    tabDescCustomers: "Verwalten Sie hier Teammitglieder und deren Kontoberechtigungen.",
    tabDescMarketing: "Überblick über Kampagnenstatus und Wachstumsleistung.",
    tabDescDiscounts: "Verwalten Sie Preisstrategien und Aktionsregeln.",
    tabDescFinance: "Überwachen Sie Finanzaufzeichnungen und Umsatztrends.",
    tabDescFinanceIncome: "Auftragsinkasso, erkannte Umsätze und Ertragskontoaufzeichnungen prüfen.",
    tabDescFinanceExpenses: "Einkaufs-, Logistik-, Marketing- und Bürokostenrechnungen verfolgen.",
    tabDescFinanceReceivables: "Forderungen, Fälligkeit und Inkassoprioriäten verfolgen.",
    tabDescFinancePayables: "Verbindlichkeiten, Lieferantenzahlungen und Fälligkeitsdruck verwalten.",
    tabDescFinanceInvoices: "Rechnungen, Quittungen und Abrechnungsstatus pflegen.",
    tabDescFinanceTax: "Ausgangssteuer, Vorsteuer und Steuervoranänderungen prüfen.",
    tabDescFinanceBudget: "Budgets, Ausgabenverteilung und Überausgabenwarnungen verfolgen.",
    tabDescFinanceDaily: "Tageseinnahmen, -ausgaben und Nettomittel zusammenfassen.",
    tabDescFinanceMonthly: "Monatlichen Abschluss erstellen und Gewinn plus Budgetabweichung prüfen.",
    tabDescFinanceYearly: "Jahresumsatz, Ausgaben, Steuern und Nettogewinn prüfen.",
    tabDescFinanceReconciliation: "Forderungen, Inkasso, Verbindlichkeiten, Rechnungen und Steuerstatus abstimmen.",
    tabDescFinanceApprovals: "Rückerstattungs-, Zahlungs- und Ausgabengenehmigungsprüfungen bearbeiten.",
    tabDescFinanceReports: "Finanzberichte, Betriebskennzahlen und Exportjobs zusammenfassen.",
    tabDescAnalytics: "Analysieren Sie grafische Erkenntnisse und operative Kennzahlen.",
    tabDescSettings: "Verwalten Sie zentrale Systemeinstellungen wie Datenbankverbindungen.",
    tabDescWorkTargets: "Verfolgen und koordinieren Sie tägliche Arbeitsziele.",
    tabDescWorkProcessing: "Bearbeiten Sie benutzerdefinierte Workflows und Ausführungsprotokolle.",
    tabDescHrEmployee: "Zeigen Sie Mitarbeiterakten und Kontoinformationen an und pflegen Sie sie.",
    tabDescHrRecruitment: "Verfolgen Sie Onboarding und auf Recruitment bezogene Aufgabenwarteschlangen.",
    tabDescHrAttendance: "Überwachen Sie Anwesenheit und Kontoaktivitätsstatus der Mitarbeiter.",
    tabDescHrOffice: "Verwalten Sie Stellenabdeckung und interne Verwaltungstätigkeiten.",
    tabDescSiteMaintenance: "Pflegen Sie Frontend-Inhalte und die Stabilität der Website.",
    tabDescPermissionMaintenance: "Pflegen Sie rollenbasierte Berechtigungen und Zugriffsgrenzen.",
    tabDescPositionMaintenance: "Pflegen Sie Stellenstrukturen und Benutzerzuordnungen.",
    tabDescProfile: "Zeigen Sie Ihre Kontoinformationen an.",
    tabDescPassword: "Ändern Sie Ihr Kontopasswort sicher.",
    tabDescInquiry: "Kommunizieren Sie mit Verkäufern und verfolgen Sie Anfragediskussionen.",
    tabDescWishlist: "Verwalten Sie gespeicherte Produkte und bevorzugte Auswahlen.",
    tabDescOrderProcessing: "Verfolgen und bearbeiten Sie Bestelldatensätze über den gesamten Lebenszyklus.",
    tabDescAfterSales: "Bearbeiten Sie After-Sales-Anfragen und Support-Tickets.",

    roleDeveloper: "Entwickler",
    roleSuperAdmin: "Superadministrator",
    roleAdmin: "Administrator",
    roleCustomer: "Kunde",
    roleGuest: "Gast",

    productCreateMenu: "Produkt veröffentlichen",
    productsMenu: "Produktliste",
    merchandisingOverview: "Merchandising-Übersicht",
    merchandisingCollection: "Auswahlpool",
    internalOverview: "Übersicht & Konfiguration",
    internalWorkspace: "Produkt & Ausführung",
    internalBusiness: "Vertrieb & Kunden",
    internalOffice: "Stellenaufgaben",
    internalMaintenance: "Wartungsboard",
    storefrontContent: "Storefront-Inhalte",
    guestService: "Gastdienste",
    customerService: "Kundendienste",
    commonAccount: "Mein Konto",
    siteMaintenanceMenu: "Stellenverwaltung",
    positionMaintenanceMenu: "Benutzerverwaltung",

    title: "Mein Shop",
    home: "Betriebsübersicht",
    storeDesign: "Shop-Einrichtung",
    companyProfile: "Unternehmensprofil",
    storeBase: "Grundparameter des Shops",
    templateStudio: "Vorlagenstudio",
    articleManagement: "Artikelverwaltung",
    companyProfileMenu: "Unternehmensprofil",
    companyImages: "Unternehmensbilder",
    designNav: "Navigationsmenüs",
    designCarousel: "Startseiten-Karussell",
    designBanner: "Banner-Einstellungen",
    faqKnowledge: "FAQ-Wissensdatenbank",
    products: "Produktverwaltung",
    productCreate: "Produktdetails hinzufügen",
    merchandising: "Merchandising-Zentrum",
    procurement: "Einkaufszentrum",
    quality: "Qualitätszentrum",
    logistics: "Logistik-Synchronisierung",
    orders: "Anfragen & Bestellungen",
    customers: "Kundenverwaltung",
    marketing: "Marketing-Kampagnen",
    discounts: "Preisstrategien",
    finance: "Finanzübersicht",
    financeIncome: "Ertragskonten",
    financeExpenses: "Ausgabenrechnungen",
    financeReceivables: "Forderungen",
    financePayables: "Verbindlichkeiten",
    financeInvoices: "Rechnungsverwaltung",
    financeTax: "Steuerverwaltung",
    financeBudget: "Budget & Ausgaben",
    financeDaily: "Tagesabrechnungen",
    financeMonthly: "Monatlicher Abschluss",
    financeYearly: "Jahresabschlüsse",
    financeReconciliation: "Abstimmung",
    financeApprovals: "Genehmigungen & Prüfung",
    financeReports: "Berichte & Export",
    analytics: "Datenanalyse",
    settings: "Systemeinstellungen",
    menuCommon: "Allgemein",
    menuInternal: "Intern",
    menuWorkContent: "Arbeitsinhalte",
    menuMaintenance: "Wartungsboard",
    userManagementGroup: "Wartungsboard",
    menuGuest: "Gast",
    menuCustomer: "Kunde",
    workTargets: "Arbeitsziele",
    workProcessing: "Arbeitsbearbeitung",
    hrEmployee: "Mitarbeiterakten",
    hrRecruitment: "Recruitment-Verwaltung",
    hrAttendance: "Anwesenheitsverwaltung",
    hrOffice: "Verwaltungsaufgaben",
    siteMaintenance: "Stellenwartung",
    permissionMaintenance: "Berechtigungswartung",
    positionMaintenance: "Benutzerverwaltung",
    profile: "Persönliche Informationen",
    password: "Passwort ändern",
    inquiry: "Anfrage-Chat",
    wishlist: "Wunschliste",
    orderProcessing: "Bestellbearbeitung",
    afterSales: "After-Sales-Service",

    profileCardTitle: "Kontoprofil",
    accountId: "Konto-ID",
    profileName: "Name",
    profileEmail: "E-Mail",
    profileRole: "Rolle",
    passwordCardTitle: "Kontopasswort ändern",
    currentPassword: "Aktuelles Passwort",
    adminResetPasswordHint: "Dies ist für Administratoren gedacht, um Passwörter von Zielbenutzern zurückzusetzen. Das aktuelle Passwort des Benutzers wird nicht benötigt.",
    newPassword: "Neues Passwort",
    confirmPassword: "Neues Passwort bestätigen",
    savePassword: "Passwort aktualisieren",
    passwordUpdated: "Passwort erfolgreich aktualisiert.",

    inquiryCardTitle: "Anfragezentrum",
    inquiryCardBody: "Kommunizieren Sie mit dem Verkäuferteam über Produktanforderungen, Preise und Lieferpläne.",
    openInquiryCenter: "Anfrageseite öffnen",
    openWhatsappChat: "WhatsApp-Chat",

    permissionSectionTitle: "Aktuelle Berechtigungen",
    permissionSectionBody: "Berechtigungen werden aus der Login-Antwort und der Stellenstruktur abgeleitet.",
    placeholderTodo: "Dieses Modul ist für die aktuelle Position geöffnet. Sie können hier spezifische Geschäftsabläufe erweitern.",

    systemConfigTitle: "Systemkonfigurationszentrum",
    settingsTabDatabase: "Datenbank",
    settingsTabDatabaseHint: "Verbindungs- und Pool-Konfiguration",
    settingsTabEmail: "E-Mail",
    settingsTabEmailHint: "Branding und transaktionale Vorlagen",
    mysqlHost: "MySQL-Host",
    mysqlPort: "MySQL-Port",
    mysqlDatabase: "MySQL-Datenbankname",
    mysqlUser: "MySQL-Benutzername",
    mysqlPassword: "MySQL-Passwort",
    mysqlPoolSize: "MySQL-Poolgröße",
    mysqlConnectTimeoutMs: "MySQL-Timeout (ms)",
    saveSystemConfig: "Systemeinstellungen speichern",
    systemConfigSavedToast: "Systemkonfiguration gespeichert",
    systemConfigPathLabel: "Konfigurationsdatei",
    restartRequiredHint: "Ein Neustart des Backend-Dienstes ist erforderlich, damit neue Datenbankeinstellungen wirksam werden.",

    storefrontTitle: "Storefront-Titel",
    adminTitle: "Titel des Admin-Panels",
    seoMetaTitle: "SEO-Titel",
    seoDescription: "SEO-Beschreibung",
    seoKeywords: "SEO-Schlüsselwörter",
    seoCanonicalUrl: "Kanonische URL",
    seoRobots: "SEO-Robots",
    seoOgTitle: "Open-Graph-Titel",
    seoOgDescription: "Open-Graph-Beschreibung",
    seoOgImage: "Open-Graph-Bild-URL",
    seoTwitterCard: "Twitter-Card-Typ",
    seoTwitterSite: "Twitter-Site-Handle",
    saveBaseSettings: "Grundeinstellungen speichern",
    baseSavedToast: "Grundeinstellungen gespeichert",

    hello: "Hallo, legen wir los.",
    askAnything: "Fragen Sie alles...",
    supportLine: "Fragen? Kontaktieren Sie den Support",
    addStoreName: "Shopnamen hinzufügen",
    firstProduct: "Fügen Sie Ihr erstes Produkt hinzu",
    firstProductDesc: "Beginnen Sie mit dem Hinzufügen eines Produkts und der Eingabe wichtiger Details.",
    addProduct: "Produkt hinzufügen",
    importData: "Importieren",
    customizeStore: "Ihren Shop anpassen",
    customizeStoreDesc: "Wählen Sie ein Template und fügen Sie Logo, Farben und Bilder hinzu.",
    customTemplate: "Individuelles Template",
    payments: "Commerce-Zahlungen einrichten",
    shipping: "Ihre Versandtarife prüfen",
    domain: "Eigene Domain",
    quickSales: "Marktverkäufe vereinfachen",
    quickSalesDesc: "Synchronisieren Sie Vertrieb und Verwaltung über mehrere Plattformen hinweg.",
    storeSettings: "Shop-Einstellungen",
    general: "Allgemein",
    billing: "Abrechnung",
    usersPermissions: "Benutzer",

    paginationPrevious: "Zurück",
    paginationNext: "Weiter",
    paginationPage: "Seite",
    paginationTotal: "von",

    policies: "Richtlinien",
    businessInfo: "Geschäftsdetails",
    contactInfo: "Shop-Kontakt",
    defaults: "Shop-Standards",
    businessMode: "Geschäftsmodus",
    b2b: "B2B",
    b2c: "B2C",
    modeSaved: "Shop-Modus aktualisiert",
    modeSavedToast: "Geschäftsmodus erfolgreich umgeschaltet",

    navSettings: "Navigationsmenü",
    navLabel: "Untermenü-Bezeichnung",
    navPath: "Untermenü-Link",
    addSubmenu: "Untermenü hinzufügen",
    saveNavigation: "Untermenüs speichern",
    navSavedToast: "Navigationsmenü gespeichert",

    bannerSettings: "Bannerliste",
    bannerTitle: "Bannertitel",
    bannerAnnotation: "Bildanmerkung",
    bannerButtonText: "Button-Text",
    bannerButtonLink: "Button-Link",
    bannerImageUrl: "Bannerbild-URL",
    addBanner: "Banner hinzufügen",
    removeBanner: "Entfernen",
    saveBanners: "Banner speichern",
    bannersSavedToast: "Bannerliste gespeichert",

    saveFaqKnowledge: "FAQs speichern",
    faqKnowledgeSavedToast: "FAQ-Wissensdatenbank gespeichert",
    saveCompanyImages: "Unternehmensbilder speichern",
    companyImagesSavedToast: "Konfiguration der Unternehmensbilder gespeichert",
    companyIntroductionTitle: "Unternehmensvorstellung",
    companyIntroductionHint: "Wird verwendet, um Profil, Vorteile und Servicekapazität zu präsentieren.",
    companyIntroductionPlaceholder: "Inhalt der Unternehmensvorstellung eingeben...",
    addImageUrl: "Bild-URL hinzufügen",
    uploadLocalImages: "Lokale Bilder hochladen",
    addFaq: "FAQ hinzufügen",
    saveCarouselImages: "Karussellbilder speichern",
    carouselImagesSavedToast: "Karussellbilder gespeichert",

    close: "Schließen",
    save: "Speichern",
    create: "Erstellen",
    search: "Aktuelle Ansicht durchsuchen",
    refresh: "Aktualisieren",
    createProduct: "Produkt hinzufügen",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    remove: "Löschen",

    systemSnapshot: "System-Snapshot",
    activeSearch: "Aktive Suche",
    none: "(Keine)",
    orderRecords: "Bestelldatensätze",
    userRecords: "Benutzerdatensätze",
    lastRefresh: "Zuletzt aktualisiert",
    productsCount: "Produkte",
    customersCount: "Kunden",
    ordersCount: "Bestellungen",
    revenue: "Umsatz USD",

    localeLabel: "Gebietsschema",
    sku: "SKU",
    name: "Name",
    description: "Beschreibung",
    price: "Preis USD",
    imageUrl: "Bild-URL",
    category: "Kategorie",
    model: "Modell",
    titleField: "Produkttitel",
    detailVideo: "Detailvideo-URL",
    mainImages: "Hauptbilder (6 Links, einer pro Zeile)",
    detailImages: "Detailbilder (einer pro Zeile)",
    parameters: "Parameter (Schlüssel:Wert pro Zeile)",
    openCreateProduct: "Produktformular öffnen",

    id: "ID",
    serialNumber: "#",
    userId: "Benutzer",
    actions: "Aktionen",
    email: "E-Mail",
    role: "Rolle",
    username: "Benutzername",
    nickname: "Spitzname",
    userRole: "Benutzerrolle",
    phone: "Telefon",
    accountStatus: "Kontostatus",
    jobTitle: "Positionsbezeichnung",
    registeredAt: "Registriert am",
    lastActiveAt: "Zuletzt aktiv",
    statusActive: "Aktiv",
    statusDisactive: "Inaktiv",
    permissions: "Berechtigungen",
    position: "Position",
    accessSummary: "Zugriff",
    positionName: "Positionsname",
    positionKey: "Positionsschlüssel",
    department: "Abteilung",
    addPosition: "Position hinzufügen",
    permissionName: "Berechtigungsname",
    permissionKey: "Berechtigungsschlüssel",
    addPermission: "Berechtigung hinzufügen",
    editPermissions: "Berechtigungen bearbeiten",
    permissionSelectTitle: "Berechtigungen auswählen",
    permissionSelectedSummary: "Ausgewählt",
    permissionQuickSearchPlaceholder: "Schnellsuche nach Schlüssel oder Kommentar",
    defaultAdminPosition: "Operations-Admin",

    orderId: "Bestell-ID",
    total: "Gesamt",
    status: "Status",
    cartItems: "Warenkorbpositionen",
    logout: "Abmelden",
    changePasswordAction: "Passwort ändern",
    userPasswordModalTitle: "Benutzerpasswort ändern",
    userPasswordUpdated: "Benutzerpasswort erfolgreich aktualisiert.",
    targetUser: "Zielbenutzer",
    userDataResyncedHint: "Nach dem Speichern wurde eine Feldüberschreibung vom Server erkannt. Neueste Daten wurden synchronisiert.",
    userManagementRestrictedHint: "Dieser Vorgang erfordert höhere Berechtigungen.",

    capability: {
      "admin:overview:read": "Admin-Übersicht lesen",
      "admin:products:read": "Admin-Produkte lesen",
      "admin:products:write": "Admin-Produkte schreiben",
      "admin:orders:read": "Admin-Bestellungen lesen",
      "admin:orders:write": "Admin-Bestellungen schreiben",
      "admin:users:read": "Admin-Benutzer lesen",
      "admin:users:role:write": "Benutzerrollen schreiben",
      "admin:users:position:assign": "Benutzerpositionen zuweisen",
      "admin:storefront:read": "Storefront-Einstellungen lesen",
      "admin:storefront:write": "Storefront-Einstellungen schreiben",
      "admin:system-config:read": "Systemkonfiguration lesen",
      "admin:system-config:write": "Systemkonfiguration schreiben",
      "shop:profile:read": "Shop-Profil lesen",
      "shop:password:write": "Shop-Passwort schreiben",
      "shop:orders:read": "Shop-Bestellungen lesen",
      "shop:inquiry:write": "Shop-Anfragen bearbeiten",
      "shop:wishlist:read": "Wunschliste lesen",
      "shop:orders:processing:read": "Bestellbearbeitung lesen",
      "shop:after-sales:read": "After-Sales lesen",
      "internal:work:targets:read": "Arbeitsziele lesen",
      "internal:work:processing:read": "Arbeitsbearbeitung lesen",
      "internal:maintenance:site:write": "Website-Wartung schreiben",
      "internal:maintenance:permission:write": "Berechtigungswartung schreiben",
      "internal:maintenance:position:write": "Positionswartung schreiben",
      "shop:products:read": "Shop-Produkte lesen",
      "shop:storefront:read": "Shop-Storefront lesen",
      "internal:system:config:read": "Interne Systemkonfiguration lesen",
      "internal:system:config:write": "Interne Systemkonfiguration schreiben",
      "internal:security:audit:read": "Sicherheitsaudit lesen",
      "internal:security:session:revoke": "Sitzung widerrufen",
      "internal:integration:manage": "Integrationen verwalten",
      "admin:users:write": "Admin-Benutzer schreiben",
      "admin:users:password:reset": "Benutzerpasswort zurücksetzen",
      "admin:users:delete": "Admin-Benutzer löschen",
      "crm:customer:read": "Kundenprofil lesen",
      "crm:customer:write": "Kundenprofil schreiben",
      "crm:customer:assign": "Kundenzuordnung vergeben",
      "website:content:read": "Website-Inhalte lesen",
      "website:content:write": "Website-Inhalte schreiben",
      "website:navigation:write": "Website-Navigation schreiben",
      "website:banner:write": "Website-Banner schreiben",
      "website:seo:write": "Website-SEO schreiben",
      "website:theme:write": "Website-Theme schreiben",
      "website:publish": "Website-Inhalte veröffentlichen",
      "admin:products:create": "Admin-Produkte erstellen",
      "admin:products:delete": "Admin-Produkte löschen",
      "merchandising:selection:read": "Auswahlpool lesen",
      "merchandising:selection:write": "Auswahlpool schreiben",
      "catalog:pricing:write": "Katalogpreise schreiben",
      "catalog:inventory:write": "Katalogbestand schreiben",
      "catalog:translation:write": "Katalogübersetzung schreiben",
      "sales:inquiry:read": "Vertriebsanfrage lesen",
      "sales:inquiry:reply": "Auf Vertriebsanfrage antworten",
      "sales:quotation:create": "Vertriebsangebot erstellen",
      "sales:quotation:approve": "Vertriebsangebot freigeben",
      "sales:contract:write": "Vertriebsvertrag schreiben",
      "sales:sample:manage": "Musterworkflow verwalten",
      "order:status:update": "Bestellstatus aktualisieren",
      "order:split:merge": "Bestellungen teilen oder zusammenführen",
      "procurement:purchase:write": "Bestellaufträge schreiben",
      "production:plan:write": "Produktionspläne schreiben",
      "qa:inspection:write": "Qualitätsprüfungen schreiben",
      "logistics:shipment:write": "Versandinformationen schreiben",
      "logistics:tracking:read": "Logistik-Tracking lesen",
      "trade:customs:doc:write": "Zolldokumente schreiben",
      "finance:invoice:read": "Rechnungen lesen",
      "finance:invoice:write": "Rechnungen schreiben",
      "finance:payment:read": "Zahlungen lesen",
      "finance:payment:write": "Zahlungen schreiben",
      "finance:refund:approve": "Rückerstattung freigeben",
      "finance:reconciliation:write": "Finanzabgleich schreiben",
      "finance:tax:write": "Steuerinformationen schreiben",
      "marketing:campaign:read": "Marketingkampagnen lesen",
      "marketing:campaign:write": "Marketingkampagnen schreiben",
      "marketing:coupon:write": "Gutscheine schreiben",
      "marketing:lead:export": "Vertriebsleads exportieren",
      "analytics:dashboard:read": "Analytics-Dashboard lesen",
      "analytics:report:export": "Analytics-Berichte exportieren",
      "support:ticket:read": "Support-Tickets lesen",
      "support:ticket:write": "Support-Tickets schreiben",
      "support:return:approve": "Rücksendeanfrage freigeben",
      "support:complaint:handle": "Kundenbeschwerden bearbeiten",
      "office:announcement:write": "Büroankündigungen schreiben",
      "office:document:read": "Bürodokumente lesen",
      "office:document:write": "Bürodokumente schreiben",
      "office:workflow:approve": "Büroworkflow freigeben",
      "office:meeting:manage": "Besprechungsplan verwalten",
      "hr:employee:read": "Mitarbeiterakten lesen",
      "hr:employee:write": "Mitarbeiterakten schreiben"
    }
  }
};